// newsReducer.js

const initialState = {
  title: "",
  slug: "",
  shortDescription: "",
  content: "",
  thumbnailImage: "",
  featuredImage: "",
  additionalImages: [],
};

const newsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_NEWS_TITLE":
      return { ...state, title: action.payload };
    case "UPDATE_NEWS_SLUG":
      return { ...state, slug: action.payload };
    case "UPDATE_NEWS_SHORT_DESCRIPTION":
      return { ...state, shortDescription: action.payload };
    case "UPDATE_NEWS_CONTENT":
      return { ...state, content: action.payload };
    case "UPDATE_NEWS_THUMBNAIL_IMAGE":
      return { ...state, thumbnailImage: action.payload };
    case "UPDATE_NEWS_FEATURED_IMAGE":
      return { ...state, featuredImage: action.payload };
    case "UPDATE_NEWS_ADDITIONAL_IMAGES":
      return { ...state, additionalImages: action.payload };
    default:
      return state;
  }
};

export default newsReducer;
